import { Injectable } from '@angular/core';
import { User } from '../../../models/User';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../../../services/user.service';

@Injectable()
export class AllUsersResolver implements Resolve<Array<User>> {

    resolve(): Observable<Array<User>> {
        return this.userService.refreshAllUsers();
    }

    constructor(private userService: UserService) { }
}
